/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Picker_SearchingInputs */

const cs_entity_picker_searching = /** @type {(inputs: Entity_Picker_SearchingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hledám…`)
};

const en_entity_picker_searching = /** @type {(inputs: Entity_Picker_SearchingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Searching…`)
};

/**
* | output |
* | --- |
* | "Searching…" |
*
* @param {Entity_Picker_SearchingInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const entity_picker_searching = /** @type {((inputs?: Entity_Picker_SearchingInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Picker_SearchingInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_picker_searching(inputs)
	return cs_entity_picker_searching(inputs)
});